import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './TooltipTransactionLog.module.scss';

const TooltipTransactionLog = ({ calendarMode }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(CN.icon, CN[calendarMode])} data-bem="TooltipTransactionLog">
      <div className={CN.tooltip}>
        {t('cashUp.cashupLogs.tooltip.description1')}
        <ul>
          <li>{t('cashUp.cashupLogs.tooltip.point1')}</li>
          <li>{t('cashUp.cashupLogs.tooltip.point2')}</li>
          <li>{t('cashUp.cashupLogs.tooltip.point3')}</li>
          <li>{t('cashUp.cashupLogs.tooltip.point4')}</li>
          <li>{t('cashUp.cashupLogs.tooltip.point5')}</li>
        </ul>
        {t('cashUp.cashupLogs.tooltip.description2')}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(TooltipTransactionLog);
